import script from "./ExpressSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ExpressSettings.vue?vue&type=script&setup=true&lang=js"

import "./ExpressSettings.vue?vue&type=style&index=0&id=17556222&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17556222"]])

export default __exports__